import React, { memo } from 'react';
import { LogoProps } from '../../types';
import { ASSETS, APP_CONFIG } from '../../constants';

const Logo: React.FC<LogoProps> = memo(({
    showText = true,
    textColor = '#F65E18',
    className = ''
}) => {
    return (
        <div className={`hero-logo ${className}`}>
            <img
                src={ASSETS.LOGO}
                alt={`${APP_CONFIG.BRAND_NAME} Logo`}
                style={{ width: '40px', height: '40px' }}
            />
            {showText && (
                <span
                    className="hero-logo-text"
                    style={{ color: textColor }}
                >
                    {APP_CONFIG.BRAND_NAME}
                </span>
            )}
        </div>
    );
});

Logo.displayName = 'Logo';

export default Logo; 